import { useState } from "react";
import { Link } from "react-router-dom";
import { VariantSelector } from "@/components/VariantSelector";
import { BuyButton } from "@/components/BuyButton";
import { formatPrice, getVariant } from "@/lib/store-helpers";

export const ProductCard = ({ product, index }) => {
  const [selectedId, setSelectedId] = useState(product.variants[0].id);
  const variant = getVariant(product, selectedId);
  const multi = product.variants.length > 1;
  const href = `/products/${product.slug}${multi ? `?variant=${variant.id}` : ""}`;

  return (
    <article
      data-testid={`product-card-${product.slug}`}
      className="fade-up group flex flex-col border border-black/10 bg-white transition-colors duration-300 hover:border-black/30"
      style={{ animationDelay: `${index * 120}ms` }}
    >
      <Link to={href} className="block overflow-hidden bg-[#EFECE6]" aria-label={product.name}>
        <img src={product.coverImage} alt={product.name} loading="lazy" className="aspect-[3/2] w-full object-contain transition-opacity duration-500 group-hover:opacity-90" />
      </Link>
      <div className="flex flex-1 flex-col gap-5 p-6 sm:p-8">
        <div>
          <p className="text-[11px] uppercase tracking-[0.2em] text-black/50">No. 0{index + 1}</p>
          <h3 className="mt-2 font-serif text-3xl leading-tight">{product.name}</h3>
          <p className="mt-2 text-sm text-black/60">{product.tagline}</p>
        </div>
        {multi && <VariantSelector product={product} selectedId={selectedId} onSelect={setSelectedId} />}
        <div className="mt-auto flex items-end justify-between gap-4">
          <p data-testid={`price-${product.slug}`} className="font-serif text-4xl leading-none">
            {formatPrice(variant.price)}
          </p>
          <Link to={href} data-testid={`view-details-${product.slug}`} className="nav-link text-[12px] font-medium uppercase tracking-[0.16em]">
            View details
          </Link>
        </div>
        <BuyButton variant={variant} testId={`buy-button-${product.slug}`} className="w-full" />
      </div>
    </article>
  );
};
